import { render, staticRenderFns } from "./ServicesWizard.vue?vue&type=template&id=641c24c7&scoped=true&"
import script from "./ServicesWizard.vue?vue&type=script&lang=ts&"
export * from "./ServicesWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c24c7",
  null
  
)

export default component.exports